export type Partner = {
  id: number;
  name: string;
  logo: string;
};

export const partnersData: Partner[] = [
  { id: 1, name: "Fondazione Comunitaria di Agrigento e Trapani", logo: "/partners/logoFCAT.png" },
  { id: 2, name: "Auxilium", logo: "/partners/auxilium.png" },
  { id: 3, name: "Lombardo", logo: "/partners/lombardo.png" },
  { id: 4, name: "Ugo", logo: "/partners/ugo.png" },
  { id: 5, name: "Carvoilà", logo: "/partners/carvoila.png" },
];